import { Reducer } from 'redux';
import {
    UtilitesState,
    UtilitiesActions,
    ToggleDebugModeActon,
    AddErrorMessageAction,
    ClearDebugMessageListAction
} from './type';
import { ADD_CONSOLE_MESSAGE, CLEAR_CONSOLE_MESSAGE, TOGGLE_DEBUG_MODE } from './constant';
import { addErrorMessage, changeDebugModeState, clearDebugMessageList } from './handlers';

export const initialState: UtilitesState = {
    isDemoModeActive: false,
    isDebugModeOn: false,
    messages: []
};

const reducer: Reducer<UtilitesState> = (state: UtilitesState = initialState, action: UtilitiesActions) => {
    switch (action.type) {
        case TOGGLE_DEBUG_MODE:
            return changeDebugModeState(state, action as ToggleDebugModeActon )
        case ADD_CONSOLE_MESSAGE:
            return addErrorMessage(state, action as AddErrorMessageAction);
        case CLEAR_CONSOLE_MESSAGE:
            return clearDebugMessageList(state, action as ClearDebugMessageListAction);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/Utilities/reducer.ts